'use client'
import { useGetBranches } from './useGetBranches';

export const useGetBranch = (branchCode?: string | null) => {
    const { data: branches } = useGetBranches();
    return branches ? branches.find((type) => type.siteCode === branchCode) : undefined;
};
